import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { LoadingDialogComponent } from 'src/app/loading-dialog/loading-dialog.component';


@Component({
  selector: 'app-faculty',
  templateUrl: './faculty.component.html',
  styleUrls: ['./faculty.component.scss']
})
export class FacultyComponent implements OnInit {
  @Input() subject;
  @Output() openDialog = new EventEmitter();
  constructor(private functions: AngularFireFunctions, private _snackBar: MatSnackBar, private dialog: MatDialog, private zone: NgZone) { }

  ngOnInit(): void {
    console.log(this.subject)
    this.subject.isWholeSubjectBought = this.subject.selectedStudyboxes.filter(sb => sb.studyboxName == 'Ceo ispit (kompletna priprema)').length > 0;
  }

  openStudyboxClipsDialog(studybox) {
    this.openDialog.next(studybox);
  }

  buyWholeSubject() {
    const dialogRef = this.dialog.open(LoadingDialogComponent,{
      disableClose:true
    })
    this.functions.httpsCallable('order-makeSubjectUpgradeRequest')({
      subject: this.subject
    }).subscribe(response => {
        this.zone.run(() => {
          console.log(response)
          dialogRef.close();
          this.subject.upgradeInProgress = true;
          this.openSnackBar("Zahtev poslat", "ok")
        })
      })
  }

  openSnackBar(message, action) {
    this._snackBar.open(message, action)
  }
}
